import { createContext } from "react";

const azureAuthProvider = createContext<() => Promise<string | void>>(() =>
  Promise.resolve()
);

export default azureAuthProvider;
